module.exports = __webpack_public_path__ + "static/media/video-inteview-tips.47e27702.svg";